import { render, staticRenderFns } from "./PlatformElderByGender.vue?vue&type=template&id=309377ea&scoped=true&"
import script from "./PlatformElderByGender.vue?vue&type=script&lang=js&"
export * from "./PlatformElderByGender.vue?vue&type=script&lang=js&"
import style0 from "./PlatformElderByGender.vue?vue&type=style&index=0&id=309377ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309377ea",
  null
  
)

export default component.exports